import { NavSkeleton, SkeletonElement } from '@bts-web/core-features/common';
import { css } from '@bts-web/utils-style-engine';
import { IMainNavigationTranslations } from '../../../layouts/LayoutWithLeftDesktopNav/utils/getMainNavigationTranslations';
import { ResponsiveLayoutWithLogo } from '../../../layouts/ResponsiveLayoutWithLogo/ResponsiveLayoutWithLogo';

export const QuestionnaireSkeleton = () => {
  return (
    <ResponsiveLayoutWithLogo
      currentLanguage="en"
      translations={{} as IMainNavigationTranslations}
    >
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: '36px',
        })}
      >
        <NavSkeleton />

        <div
          className={css({
            display: 'flex',
            px: 'medium',
            flexDirection: 'column',
            gap: '5px',
          })}
        >
          <SkeletonElement maxWidth="100%" width="350px" height="30px" />

          <SkeletonElement width="100px" height="30px" />
        </div>
      </div>
    </ResponsiveLayoutWithLogo>
  );
};
